<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Internal Complaint Committee</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
    <section class="section-lg std-scholarship">
        <div class="container">
            <div class="table-responsive" >
                <table class="table table-bordered text-center tbl_custom">
                    <thead>
                        <tr>
                            <th>Sr. No</th>
                            <th>Name</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                       
                        <tr>
                            <td>1</td>
                            <td>Dr Jasvinder Kaur</td>
                            <td>Presiding officer</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Ms Kanchan Manjre</td>
                            <td>Teaching Representatitve</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>CA Prachi Ranade</td>
                            <td>Teaching Representatitve</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Mr. Yusuf Khan</td>
                            <td>Non- Teaching Representative</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Mr. Sachin Bhosale</td>
                            <td>Non- Teaching Representative</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Ms Deepika Khemani</td>
                            <td>Students Representative</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>Mr Arjit Gupta</td>
                            <td>Students Representative</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>Ms Anuyha Kumandari</td>
                            <td>Students Representative</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
